import PropTypes from 'prop-types'
import React from 'react'
import { pastRollover } from 'helpers/moment'
import classes from './Summary.scss'
import Button from 'components/Button'

export const OrdersSummary = (props) => {
  if (!props.orders.length || !props.isLoggedIn) return null
  const unprinted = props.orders.filter(order => !order.printed_at)

  return <div className={classes['summary']}>
    <h3 className={classes['title']}>{pastRollover() && `Today's` || `Tomorrow's`} Orders</h3>
    <h1 className={classes['number']}>{props.orders.length}</h1>

    <Button options={['purple']} element='a' href='/orders/list'>
      View Order
    </Button>

    {props.isAdmin && <Button options={['green']} element='a' href='/process'>
      Fulfillment View{unprinted.length ? ` (${unprinted.length})` : ''}
    </Button>}
  </div>
}

OrdersSummary.propTypes = {
  orders: PropTypes.array.isRequired,
  params: PropTypes.object,
  date: PropTypes.any,
  isLoggedIn: PropTypes.bool,
  isAdmin: PropTypes.bool
}

export default OrdersSummary



// WEBPACK FOOTER //
// ./src/components/Orders/Summary/Summary.js